
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FulfilledLayout } from 'spa-ionata-admin/types';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import GalleryLayout from 'spa-ionata-admin/lib/components/GalleryLayout.vue';
import Business from '../models/Business';

@Component({ components: { MediaImg, GalleryLayout } })
export default class extends Vue {
  @Prop(Object) readonly business!: Business;

  get layouts(): FulfilledLayout[] {
    return this.business.getGalleryMediaIds() || [];
  }
}
